import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Shield, Users, HardHat, TrendingUp, CheckCircle2, 
  Settings, FileSpreadsheet, Calculator, ArrowLeft, UserPlus, Briefcase, 
  ArrowRight, MessageSquareMore
} from 'lucide-react';

const PortafolioServicios = ({ language }) => { 
  
  const navigate = useNavigate();

  // --- DICCIONARIO DE TEXTOS CON ENFOQUE DE OFERTA DE VALOR INTEGRAL Y SEO ---
  const t = {
    es: {
      back: "Volver al Inicio",
      heroTag: "Consultoría Empresarial y Soluciones Corporativas 360°",
      heroTitle: "Ecosistema Integral de Gestión",
      heroSubtitle: "Para Proteger y Escalar tu Empresa",
      heroDesc: "No somos un proveedor de paso. En Zaphy nos convertimos en el aliado estratégico que asume la carga operativa, blinda tu responsabilidad legal ante entes de control y digitaliza los procesos de tu PyME.",
      
      // Lista de Servicios con Copies Potenciados
      sstTitle: "Seguridad y Salud en el Trabajo (SG-SST)",
      sstDesc: "Diseño, implementación y administración obligatoria bajo el Decreto 1072 y Res. 0312. Asumimos el área y te blindamos ante visitas del Ministerio.",
      rrhhTitle: "Outsourcing de Recursos Humanos",
      rrhhDesc: "Tu departamento externo de gestión humana. Controlamos la cultura, los procesos disciplinarios de ley y la retención del talento técnico.",
      seleccionTitle: "Selección de Personal & Headhunting",
      seleccionDesc: "Encontramos perfiles calificados mediante psicología organizacional y filtros técnicos avanzados. Con garantía de reposición a costo cero.",
      nominaTitle: "Outsourcing de Nómina Electrónica",
      nominaDesc: "Liquidación exacta de salarios, prestaciones contractuales y transmisión PILA/DIAN. Blindaje absoluto frente a fiscalizaciones de la UGPP.",
      estructuraTitle: "Estructura Organizacional & Procesos",
      estructuraDesc: "Ingeniería de procesos corporativos. Diseñamos manuales de funciones y flujos de trabajo optimizados para automatizar la operación.",
      independientesTitle: "Servicios Laborales Independientes",
      independientesDesc: "Afiliaciones express a seguridad social, contratos a la medida y auditorías documentales por proyectos. Soluciones de pago por uso.",
      
      viewDetails: "Ver alcances del servicio",
      
      seoTitle: "Preguntas Frecuentes sobre Soluciones de Outsourcing Corporativo",
      seoSubtitle: "Resolvemos tus dudas sobre la integración de servicios de gestión humana, riesgos laborales y contabilidad con Zaphy.",
      faqs: [
        { q: '¿Qué beneficios tiene centralizar múltiples servicios de gestión con un solo aliado como Zaphy?', a: 'Centralizar tu nómina, la seguridad en el trabajo (SST) y el área de recursos humanos con Zaphy elimina la fricción de proveedores dispersos. Asegura que la comunicación fluya sin errores, unifica tus flujos de información contable y legal, y reduce drásticamente los costos operativos fijos de tu PyME.' },
        { q: '¿Zaphy asume la responsabilidad contractual por los procesos que ejecuta?', a: 'Sí. A diferencia de las consultoras tradicionales que solo emiten recomendaciones o softwares pasivos que tú debes alimentar, en Zaphy nos involucramos en la operación diaria, firmamos como responsables técnicos con licencias vigentes y asumimos contractualmente el debido proceso legal.' },
        { q: '¿Sus servicios puntuales y outsourcing mensuales cumplen con las últimas reformas del Gobierno?', a: 'Absolutamente. Nuestro comité legal contable monitorea en tiempo real las actualizaciones normativas del Ministerio de Trabajo, la DIAN y la UGPP. Cada proceso, liquidación o manual se reestructura de forma inmediata bajo las leyes vigentes en Colombia.' },
        { q: '¿Cómo ayuda la reestructuración de procesos a que mi negocio opere sin depender de mí?', a: 'A través de la ingeniería de la estructura organizativa. Al documentar manuales de funciones claros y mapear flujos operativos automatizados, el conocimiento deja de estar en la cabeza del dueño y se transfiere a un sistema replicable, permitiendo que el equipo trabaje con total autonomía.' }
      ],
      
      // CTA
      ctaTitle: "¿No estás seguro de cuál es el punto de partida para tu PyME?",
      ctaDesc: "Agenda un diagnóstico estratégico gratuito de 15 minutos. Analizamos el estado legal, contable y operativo actual de tu empresa y te entregamos la hoja de ruta exacta para mitigar riesgos.",
      ctaBtnQuote: "Solicitar Propuesta",
      ctaBtnAdvisor: "Escríbenos por WhatsApp"
    },
    en: {
      back: "Back to Home",
      heroTag: "Business Consulting and 360° Corporate Solutions",
      heroTitle: "Comprehensive Management Ecosystem",
      heroSubtitle: "To Protect and Scale Your Business",
      heroDesc: "We are not just a passing vendor. At Zaphy, we become the strategic ally that takes over the operational burden, shields your legal liability before control entities, and digitalizes your PyMEs processes.",
      
      sstTitle: "Occupational Health & Safety (SG-SST)",
      sstDesc: "Mandatory design, implementation, and management under Decree 1072 and Res. 0312. We take over the department and shield you from Ministry audits.",
      rrhhTitle: "Human Resources Outsourcing",
      rrhhDesc: "Your external personnel management department. We control corporate culture, legal disciplinary hearings, and technical talent retention.",
      seleccionTitle: "Personnel Selection & Headhunting",
      seleccionDesc: "We find qualified profiles through organizational psychology and advanced technical filters. With a zero-cost replacement guarantee.",
      nominaTitle: "Electronic Payroll Outsourcing",
      nominaDesc: "Accurate calculation of salaries, contractual benefits, and PILA/DIAN submission. Absolute shielding against UGPP audits.",
      estructuraTitle: "Organizational Structure & Processes",
      estructuraDesc: "Corporate process engineering. We design job manuals and optimized workflows to automate your company operations.",
      independientesTitle: "Independent Labor Services",
      independientesDesc: "Express social security affiliations, custom contracts, and project-based document audits. Pay-per-use solutions.",
      
      viewDetails: "View service scope",
      
      seoTitle: "Frequently Asked Questions about Corporate Outsourcing Solutions",
      seoSubtitle: "We solve your doubts about integrating human management, workplace risks, and accounting services with Zaphy.",
      faqs: [
        { q: 'What are the benefits of centralizing multiple management services with a single ally like Zaphy?', a: 'Centralizing your payroll, safety at work (OHS), and human resources with Zaphy eliminates the friction of scattered vendors. It ensures that communication flows smoothly, unifies your accounting and legal information workflows, and drastically reduces fixed operational costs.' },
        { q: 'Does Zaphy assume contractual responsibility for the processes it executes?', a: 'Yes. Unlike traditional consulting firms that only issue recommendations or passive software that you must manage, at Zaphy we get involved in daily operations, sign as technical managers with valid licenses, and assume due process.' },
        { q: 'Do your one-off services and monthly outsourcing comply with the latest Government reforms?', a: 'Absolutely. Our legal and accounting committee monitors in real time any updates from the Ministry of Labor, DIAN, and UGPP. Every process, liquidation, or manual is restructured immediately under the current Colombian laws.' },
        { q: 'How does process restructuring help my business operate without depending on me?', a: 'Through organization structure engineering. By documenting clear job descriptions and mapping automated operational workflows, knowledge stops being only in the owners head and is transferred into a replicable system.' }
      ],
      
      ctaTitle: "Not sure where the starting point is for your PyME?",
      ctaDesc: "Schedule a free 15-minute strategic diagnosis. We analyze your company's current legal, accounting, and operational status and give you the exact roadmap to mitigate risks.",
      ctaBtnQuote: "Request Proposal",
      ctaBtnAdvisor: "Chat on WhatsApp"
    }
  };

  const text = t[language] || t.es;

  // Manejador para el desvío directo a WhatsApp corporativo
  const handleWhatsAppRedirect = () => {
    const targetUrl = `https://api.whatsapp.com/send?phone=573114044203&text=${encodeURIComponent("¡Hola, Zaphy! 🚀 Estuve revisando su Portafolio Integral 360° en la web y quiero agendar el diagnóstico gratuito de 15 miutos para revisar el estado legal y operativo de mi PyME.")}`;
    window.open(targetUrl, '_blank');
  };

  const servicesList = [
    {
      id: 'sst',
      title: text.sstTitle,
      desc: text.sstDesc,
      icon: HardHat,
      borderColor: "hover:border-[#E1FC01]",
      bgHover: "group-hover:text-[#E1FC01]",
      textAcc: "text-[#E1FC01]",
      bgIcon: "bg-[#E1FC01] text-black",
      gradient: "from-[#E1FC01]"
    },
    {
      id: 'recursos-humanos',
      title: text.rrhhTitle,
      desc: text.rrhhDesc,
      icon: Users,
      borderColor: "hover:border-cyan-500",
      bgHover: "group-hover:text-cyan-300",
      textAcc: "text-cyan-200",
      bgIcon: "bg-cyan-500 text-white",
      gradient: "from-cyan-500"
    },
    {
      id: 'seleccion-personal',
      title: text.seleccionTitle,
      desc: text.seleccionDesc,
      icon: UserPlus,
      borderColor: "hover:border-pink-500",
      bgHover: "group-hover:text-pink-300",
      textAcc: "text-pink-200",
      bgIcon: "bg-pink-500 text-white",
      gradient: "from-pink-500"
    },
    {
      id: 'nomina',
      title: text.nominaTitle,
      desc: text.nominaDesc,
      icon: FileSpreadsheet,
      borderColor: "hover:border-green-500",
      bgHover: "group-hover:text-green-300",
      textAcc: "text-green-200",
      bgIcon: "bg-green-600 text-white",
      gradient: "from-green-500"
    },
    {
      id: 'estructura-organizacional',
      title: text.estructuraTitle,
      desc: text.estructuraDesc,
      icon: TrendingUp,
      borderColor: "hover:border-[#8B0C3C]",
      bgHover: "group-hover:text-[#ff4d94]",
      textAcc: "text-[#ff80b3]",
      bgIcon: "bg-[#8B0C3C] text-white",
      gradient: "from-[#8B0C3C]"
    },
    {
      id: 'servicios-independientes',
      title: text.independientesTitle,
      desc: text.independientesDesc,
      icon: Settings,
      borderColor: "hover:border-indigo-500",
      bgHover: "group-hover:text-indigo-300",
      textAcc: "text-indigo-200",
      bgIcon: "bg-indigo-500 text-white",
      gradient: "from-indigo-500"
    }
  ];

  return (
    <div className="animate-[fadeIn_0.5s_ease-out] pt-32 pb-20 min-h-screen bg-gray-50 font-[Poppins]">
      
      {/* --- 1. HERO SECTION (ENCABEZADO INTEGRAL DE MARCA) --- */}
      <div className="relative bg-[#0F172A] text-white py-20 overflow-hidden mb-16">
         <div className="absolute inset-0 opacity-20 bg-cover bg-center" style={{ backgroundImage: `url('https://www.transparenttextures.com/patterns/cubes.png')` }}></div>
         <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-purple-600/20 rounded-full blur-[100px] -mr-32 -mt-32"></div>
         <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-cyan-600/20 rounded-full blur-[100px] -ml-32 -mb-32"></div>

         <div className="max-w-7xl mx-auto px-4 relative z-10 text-center">
            <button onClick={() => navigate('/')} className="absolute left-4 top-0 md:left-0 flex items-center gap-2 text-white/50 hover:text-white transition-colors font-medium text-sm uppercase tracking-wider">
               <ArrowLeft size={16} /> {text.back}
            </button>
            
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-purple-200 font-bold text-sm mb-6 mt-8 md:mt-0">
               <Briefcase size={16} /> {text.heroTag}
            </div>

            <h1 className="text-3xl md:text-6xl font-extrabold mb-6 leading-tight">
               {text.heroTitle} <br/>
               <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-cyan-400">{text.heroSubtitle}</span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
               {text.heroDesc}
            </p>
         </div>
      </div>

      {/* --- 2. GRID DE SERVICIOS CORPORATIVOS --- */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-24">
         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {servicesList.map((service) => (
              <div 
                key={service.id}
                onClick={() => navigate(`/${service.id}`)}
                className={`group relative bg-white p-8 rounded-[30px] shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl ${service.borderColor} cursor-pointer overflow-hidden`}
              >
                  <div className={`absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500 bg-gradient-to-br ${service.gradient} to-transparent`}></div>
                  
                  <div className="relative z-10">
                      <div className="flex justify-between items-start mb-6">
                          <div className={`w-14 h-14 ${service.bgIcon} rounded-2xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300`}>
                             <service.icon size={28} />
                          </div>
                          <div className="bg-gray-50 p-2 rounded-full group-hover:bg-white transition-colors">
                             <ArrowRight size={20} className="text-gray-400 group-hover:text-gray-900" />
                          </div>
                      </div>
                      
                      <h3 className="text-xl md:text-2xl font-bold mb-3 text-gray-900 group-hover:text-gray-700 transition-colors">
                          {service.title}
                      </h3>
                      
                      <p className="text-gray-500 text-xs md:text-sm leading-relaxed mb-5 group-hover:text-gray-600 min-h-[48px]">
                          {service.desc}
                      </p>

                      <span className="text-xs font-bold uppercase tracking-wider text-purple-500 group-hover:text-cyan-500 transition-colors">
                          {text.viewDetails}
                      </span>
                  </div>
              </div>
            ))}
         </div>
      </div>

      {/* --- 2.5: BLOQUE DE PREGUNTAS FRECUENTES (SEO BOOST SEMÁNTICO) --- */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mb-24">
         <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-2">{text.seoTitle}</h2>
            <p className="text-gray-500 text-xs md:text-sm">{text.seoSubtitle}</p>
         </div>
         <div className="space-y-4">
            {text.faqs.map((faq, idx) => (
               <div key={idx} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:border-slate-200 transition-all">
                  <h3 className="text-sm md:text-base font-bold text-gray-950 mb-2 flex items-start gap-2">
                     <span className="text-purple-500 shrink-0">❓</span> {faq.q}
                  </h3>
                  <p className="text-gray-600 text-xs md:text-sm leading-relaxed pl-6">{faq.a}</p>
               </div>
            ))}
         </div>
      </div>

      {/* --- 3. CTA FINAL DE TRIPLE ACCIÓN --- */}
      <div className="max-w-5xl mx-auto px-4 text-center">
         <div className="bg-gradient-to-br from-gray-900 to-[#0F172A] rounded-[40px] p-12 text-white shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-purple-500/20 rounded-full blur-3xl -mr-16 -mt-16"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-cyan-500/20 rounded-full blur-3xl -ml-16 -mb-16"></div>
            
            <div className="relative z-10">
                <h2 className="text-2xl md:text-4xl font-extrabold mb-6">{text.ctaTitle}</h2>
                <p className="text-gray-300 text-base md:text-lg mb-8 max-w-2xl mx-auto">
                   {text.ctaDesc}
                </p>
                
                <div className="flex flex-col sm:flex-row justify-center gap-4">
                    <button 
                        onClick={() => navigate('/cotizador')}
                        className="bg-white text-gray-900 font-bold py-4 px-8 rounded-xl shadow-lg hover:bg-gray-100 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 text-xs md:text-sm uppercase tracking-wide"
                    >
                        <Calculator size={20}/>
                        {text.ctaBtnQuote}
                    </button>

                    <button 
                        onClick={handleWhatsAppRedirect}
                        className="bg-emerald-600 text-white font-bold py-4 px-8 rounded-xl shadow-lg hover:bg-emerald-700 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 text-xs md:text-sm uppercase tracking-wide"
                    >
                        <MessageSquareMore size={20}/>
                        {text.ctaBtnAdvisor}
                    </button>
                </div>
            </div>
         </div>
      </div>

    </div>
  );
};

export default PortafolioServicios;